<script lang="ts" setup>
import GwMenuNew from '@/components/lib/GwMenuNew/GwMenuNew.vue'
import GwBox from '@/components/lib/GwBox/GwBox.vue'
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'
import GwText from '@/components/lib/base/GwText/GwText.vue'

export interface GwSelectProps {
  isInside?: boolean
  title?: string
  closeOnContentClick?: boolean
  closeOnScroll?: boolean
}

withDefaults(defineProps<GwSelectProps>(), {})
</script>

<template>
  <GwMenuNew
    placement="bottom-start"
    :isInside
    :closeOnContentClick
    :closeOnScroll
  >
    <template #opener="{ listeners, isOpen }">
      <GwBox
        class="no-shrink f-center"
        variant="box_select"
        v-bind="$attrs"
        v-on="listeners"
      >
        <GwText
          variant="text_grey_medium_500"
          class="text-nowrap truncate"
          v-html="title"
        />
        <slot name="opener_content"></slot>
        <GwBtn
          class="ml-auto"
          data-tst="select_opener"
          variant="btn_text_grey_white"
          :icon="isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'"
        />
      </GwBox>
    </template>
    <template #content="{ methods }">
      <slot
        name="content"
        :methods
      >
        select-content
      </slot>
    </template>
  </GwMenuNew>
</template>
